import react, {useEffect} from 'react';
import {useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import {getnkdSidApi } from "../../http/request";
import { useStore } from "../../store/store";
import { modalAlert } from "../../component/Modal/index";
const Index = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
    const {updatenKdSid, updateUserName, updateToken, updateTokenExpireAt} = useStore((state) => state);
    /**
   * @description 获取用户sid
   * @param ticket 
   */
    const getnkdSid = async (ticket: string) => {
        const res = await getnkdSidApi({
          ticket
        })
        if (res.data.code == 0) {
            updatenKdSid(res.data.sid)
            updateUserName(res.data.name)
            // 保存 XCX-Token 及过期时间（后端返回的 expire 为秒），后续所有接口请求统一在 http 拦截器携带
            updateToken(res.data.token)
            updateTokenExpireAt(Date.now() + Number(res.data.expire || 0) * 1000)
            navigate('/')
            return
        }
        await modalAlert({
          title: t("TS"),
          content: res.data.msg,
          confirmText: t("ZDL"),
        });
      }
    useEffect(() => {
    if (searchParams.get('ticket') &&  window.localStorage.getItem('ticket') != searchParams.get('ticket')) {
      window.localStorage.setItem('ticket', searchParams.get('ticket') as string)
      getnkdSid(searchParams.get('ticket') as string)
  } 
    }, [searchParams.get('ticket')])
    return <div>

    </div>
}

export default react.memo(Index)